module.exports = __webpack_public_path__ + "static/media/UP_PMS_Notice_Aadhar_Card.c65eb694.pdf";